// extracted by mini-css-extract-plugin
export var markdown = "_s9-0";
export var tableWrapper = "_s9-1";